"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useThrottle", {
    enumerable: true,
    get: function() {
        return _useThrottle.useThrottle;
    }
});
const _useThrottle = require("./useThrottle");
